import React, { useEffect, useState } from "react";
import { ActivityIndicator, Dimensions, Image, Linking, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

import AsyncStorage from "@react-native-async-storage/async-storage";
import toast from "../../utils/toast";
import paymentService from "../../services/paymentService";
import CreditCardList from "../../components/CreditCardList";
import GradientButton from "../../components/GradientButton";

const DepositCreditCard = () => {
  const navigation = useNavigation();

  const [selectedCard, setSelectedCard] = useState();
  function onCardChanged(card) {
    setSelectedCard(card);
  }

  function addNewCreditCard() {
    navigation.navigate('DepositNewCreditCard');
  }

  function continueWithSelected() {
    navigation.navigate({ name: 'DepositCreditCardSummary', params: { selectedCard } });
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderDefault title={"Depositar BRL"} />
      <View style={styles.container}>
        <CreditCardList onCardChanged={onCardChanged} onEmpty={addNewCreditCard} />

        <View style={styles.buttons}>
          <GradientButton onPress={addNewCreditCard}>Adicionar novo cartão</GradientButton>
          <GradientButton disabled={!selectedCard} onPress={continueWithSelected} style={styles.useSelectedButton}>Continuar com cartão selecionado</GradientButton>
        </View>
      </View>
    </View>
  );
};

export default DepositCreditCard;
